<template>
  <div class="page-content">
    <div class="page-title">
      <h5>我的开题报告</h5>
    </div>
    <div class="panel">
      <div class="">
        <!-- <div class="normal tm_navbuttons">
          <template
            v-if="
              !thesisProposal &&
              config &&
              $utils.toTime(config.guidanceStartTime) < nowDate &&
              $utils.toTime(config.guidanceEndTime) > nowDate
            "
          >
            <el-button type="primary" size="mini" @click="addThesisProposal()"
              >提交开题报告</el-button
            >
          </template>
          <template
            v-if="
              thesisProposal &&
              config &&
              $utils.toTime(config.guidanceStartTime) < nowDate &&
              $utils.toTime(config.guidanceEndTime) > nowDate &&
              1 != thesisProposal.checkStatus
            "
          >
            <el-button
              type="primary"
              size="mini"
              @click="updateThesisProposal()"
              >更新开题报告</el-button
            >
          </template>
        </div> -->
        <div class="normal">
          <template
            v-if="
              config.notice &&
              (!$utils.toTime(config.noticetaskAssignEndDate) || $utils.toTime(config.noticetaskAssignEndDate) > nowDate)
            "
          >
            <div >
              <span class="red">考生论文须知：</span>
              <div id="t_notice_content" v-html="config.notice" class="t_notice_content"></div>
            </div>
            <input type="hidden" id="boo" value="true" />
          </template>
        </div>
        <div class="normal_box">
          <div class="zs_table">
            <table
              width="100%"
              cellpadding="5"
              border="0"
              class="tm_table_form"
            >
              <tbody>
                <template v-if="configs">
                  <tr>
                    <th style="width: 200px">批次 :</th>
                    <td>
                      <el-select
                        size="mini"
                        v-model="defaultThesisBatchId"
                        @change="getInfo"
                      >
                      <el-option
                      v-for="item in configs"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                </template>

                <tr>
                  <th style="width: 200px">开题报告提交时间:</th>
                  <td v-if="thesisProposal">
                    {{
                      config.guidanceStartTime
                    }}
                    至
                    {{
                      config.guidanceEndTime
                    }}
                  </td>
                </tr>
                <tr v-if="bm && bm.teacherName && bm.teacherPhone">
                  <th>指导老师 :</th>
                  <td style="color: red;">
                    {{ bm.teacherName }}({{ bm.teacherPhone }}) 论文相关问题，请与老师联系。
                  </td>
                </tr>

                <tr>
                  <th>论文方向:</th>
                  <td style="font-weight: normal" v-if="thesisProposal">
                    {{ thesisProposal.direction }}
                  </td>
                </tr>
                <tr>
                  <th>题目:</th>
                  <td v-if="thesisProposal">{{ thesisProposal.title }}</td>
                </tr>
              
                <!-- <template
                >
                  <tr>
                    <th>状态:</th>
                    <td >
                      <template v-if="thesisProposal">
                      <span v-if="thesisProposal.checkStatus==0">未指导</span>
                      <span v-if="thesisProposal.checkStatus==-1" style="color: red;">打回修改</span>
                      <span v-if="thesisProposal.checkStatus==1">已指导</span>
                    </template>
                    </td>
                  </tr>
                </template>
                <template
                  v-if="thesisProposal && thesisProposal.checkStatus != 0"
                >
                  <tr>
                    <th>指导意见:</th>
                    <td>
                      <pre>{{ thesisProposal.remark }}</pre>
                    </td>
                  </tr>
                </template> -->
              </tbody>
            </table>
          </div>
        </div>
        <div class="pledge-section" v-if="!taskBook.studentPromiseSign">
          <div class="pledge-section__header">
            <span>诚信承诺书签名</span>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="openPledgeDialog"
            >
              扫码签名
            </el-button>
          </div>
          <div class="pledge-section__body">
            <template v-if="pledgeSign">
              <img :src="pledgeSign" alt="承诺书签名" />
              <el-button type="text" size="mini" @click="openPledgeDialog">
                重新签名
              </el-button>
            </template>
            <span v-else class="pledge-section__placeholder"
              >尚未签名，请点击上方按钮完成签名</span
            >
          </div>
        </div>

        <!-- 任务书和开题报告填写区域 -->
        <div v-if="taskBook.studentPromiseSign || pledgeSign" class="task-proposal-section">
          <!-- 标签页 -->
          <el-tabs v-model="activeTab" type="card" class="task-proposal-tabs">
            <!-- 任务书标签页 -->
            <el-tab-pane label="任务书" name="taskbook">
              <el-form
                :model="taskBookForm"
                :rules="taskBookRules"
                ref="taskBookForm"
                size="small"
                label-width="212px"
                :disabled="taskBook.studentTaskBookSign"
              >
              <el-form-item label="任务起止时间" required>
                <el-col :span="11">
                  <el-form-item prop="taskAssignStartDate">
                    <el-date-picker
                      v-model="taskBookForm.taskAssignStartDate"
                      type="datetime"
                      placeholder="请选择开始时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="taskAssignEndDate">
                    <el-date-picker
                      v-model="taskBookForm.taskAssignEndDate"
                      type="datetime"
                      placeholder="请选择结束时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>

                <el-form-item prop="mainContent" label="毕业论文(设计)主要内容">
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="taskBookForm.mainContent"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item prop="mainWorkPlan" label="毕业论文(设计)的主要阶段计划">
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="分前期、中期、后期"
                    v-model="taskBookForm.mainWorkPlan"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item prop="studentTaskBookSign" label="电子签名">
                  <div class="pledge-sign-box">
                    <img v-if="taskBookForm.studentTaskBookSign" :src="taskBookForm.studentTaskBookSign" @click="openTaskBookSignDialog" class="pledge-sign-preview" alt="签名预览" />
                    <el-link v-else :underline="false" type="primary" @click="openTaskBookSignDialog">点击扫码签名</el-link>
                  </div>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <!-- 开题报告标签页 -->
            <el-tab-pane label="开题报告" name="proposal">
              <el-form
                :model="proposalForm"
                :rules="proposalRules"
                ref="proposalForm"
                size="small"
                label-width="212px"
                :disabled="(thesisProposal.outline1 && thesisProposal.checkStatus == 0)"
              >
                <el-form-item
                  prop="outline1"
                  label="一、论文（设计）选题的依据（选题的目的和意义、该选题在国内外的研究现状及发展趋势、主要参考文献等）"
                >
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="proposalForm.outline1"
                    maxlength="1000"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="outline2"
                  label="二、论文（设计）的主要研究内容及预期目标"
                >
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="proposalForm.outline2"
                    maxlength="1000"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="outline3"
                  label="三、论文（设计）的主要研究方案（拟采用的研究方法、准备工作情况及主要措施）"
                >
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="proposalForm.outline3"
                    maxlength="1000"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="outline4"
                  label="四、论文（设计）研究工作进展安排"
                >
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="proposalForm.outline4"
                    maxlength="1000"
                    show-word-limit
                  ></el-input>
                </el-form-item>

                <table
                  v-if="thesisProposal.checkStatus != 0"
                  width="100%"
                  cellpadding="5"
                  border="0"
                  class="tm_table_form"
                >
                  <tbody>
                    <template
                    >
                      <tr>
                        <th>状态:</th>
                        <td >
                          <template v-if="thesisProposal">
                          <span v-if="thesisProposal.checkStatus==0">未指导</span>
                          <span v-if="thesisProposal.checkStatus==-1" style="color: red;">打回修改</span>
                          <span v-if="thesisProposal.checkStatus==1">已指导</span>
                        </template>
                        </td>
                      </tr>
                    </template>
                    <template
                      v-if="thesisProposal && thesisProposal.checkStatus != 0"
                    >
                      <tr>
                        <th>指导意见:</th>
                        <td>
                          <pre>{{ thesisProposal.remark }}</pre>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </el-form>
            </el-tab-pane>
          </el-tabs>

          <!-- 提交按钮 -->
          <div class="submit-buttons">
            <el-button type="primary" size="mini" @click="submitTaskBook" v-if="activeTab === 'taskbook' && !taskBook.studentTaskBookSign">
              提交任务书
            </el-button>
            <el-button type="primary" size="mini" @click="submitProposal" v-if="activeTab === 'proposal' && !thesisProposal.outline1">
              提交开题报告
            </el-button>
            <el-button type="primary" size="mini" @click="submitProposal" v-if="activeTab === 'proposal' && thesisProposal.checkStatus == -1">
              更新开题报告
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <PledgeDialog
      ref="pledgeDialog"
      @confirm="onPledgeConfirm"
      @sign-selected="onSignSelected"
    />
    <Notice ref="Notice" />

    <SignDialog ref="signDialog" @sign-success="onSign"></SignDialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {
    Notice: () => import("../Notice.vue"),
    PledgeDialog: () => import("./PledgeDialog.vue"),
    SignDialog: () => import("./SignDialog.vue"),
  },
  data() {
    return {
      configs: [],
      info: {},
      defaultThesisBatchId: "",
      config: {},
      thesisProposal: null,
      thesis: null,
      db: null,
      logs: [],
      bm: null,
      curTime: "",
      nowDate: new Date().getTime(),
      form: {},
      pledgeSign: "",
      taskBook: {},
      activeTab: "taskbook",
      taskBookForm: {
        taskAssignStartDate: "",
        taskAssignEndDate: "",
        mainContent: "",
        mainWorkPlan: "",
        studentTaskBookSign: "",
      },
      taskBookRules: {
        taskAssignStartDate: [{ required: true, message: "请选择活动开始日期", trigger: "change" }],
        taskAssignEndDate: [
          { required: true, message: "请选择活动结束日期", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              if (!this.taskBookForm.taskAssignStartDate) {
                callback();
                return;
              }
              const startTime = new Date(this.taskBookForm.taskAssignStartDate).getTime();
              const endTime = new Date(value).getTime();
              if (endTime <= startTime) {
                callback(new Error("结束时间不能早于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        mainContent: [{ required: true, message: "请输入毕业论文(设计)主要内容", trigger: "blur" }],
        mainWorkPlan: [{ required: true, message: "请输入毕业论文(设计)的主要阶段计划", trigger: "blur" }],
        studentTaskBookSign: [{ required: true, message: "请完成电子签名", trigger: "change" }],
      },
      proposalForm: {
        outline1: "",
        outline2: "",
        outline3: "",
        outline4: "",
      },
      proposalRules: {
        outline1: [
          { required: true, message: "请填写论文（设计）选题的依据", trigger: "blur" },
          // { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline2: [
          { required: true, message: "请填写论文（设计）的主要研究内容及预期目标", trigger: "blur" },
          // { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline3: [
          {
            required: true,
            message: "请填写论文（设计）的主要研究方案",
            trigger: "blur",
          },
          // { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
        outline4: [
          { required: true, message: "请填写论文（设计）研究工作进展安排", trigger: "blur" },
          // { min: 100, message: "最少100个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.thesisBatchId) this.defaultThesisBatchId =+ this.$route.query.thesisBatchId;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http
        .post("/student/thesis2/myThesis", { thesisBatchId: this.defaultThesisBatchId })
        .then(res => {
          // this.$http.get("/student/taskbook/getTaskBook", { thesisProposalId: res.thesisProposal.id })
          //   .then(response => {
          //     console.log(response);
              
          //   })
          if (!res?.taskBook?.studentPromiseSign) {
            this.$nextTick(() => {
              this.openPledgeDialog()
            })
          }

          this.config = res.config;
          this.taskBook = res.taskBook || {};
          this.configs = res.configs;
          this.info = res;
          if (!this.defaultThesisBatchId) this.defaultThesisBatchId = res.defaultThesisBatchId;
          this.thesisProposal = res.thesisProposal;
          this.thesis = res.thesis;
          this.db = res.db;
          this.bm = res.bm;
          this.logs = res.logs;
          this.curTime = res.curTime;
          this.reportLogId = res.reportLogId;
          this.pledgeSign =
            (res.thesisProposal && res.thesisProposal.signImg) || "";
          
          // 初始化任务书表单数据
          if (res.taskBook) {
            this.taskBookForm = {
              taskAssignStartDate: res.taskBook.taskAssignStartDate || "",
              taskAssignEndDate: res.taskBook.taskAssignEndDate || "",
              mainContent: res.taskBook.mainContent || "",
              mainWorkPlan: res.taskBook.mainWorkPlan || "",
              studentTaskBookSign: res.taskBook.studentTaskBookSign || "",
            };
          }
          
          // 初始化开题报告表单数据
          if (res.thesisProposal) {
            this.proposalForm = {
              outline1: res.thesisProposal.outline1 || "",
              outline2: res.thesisProposal.outline2 || "",
              outline3: res.thesisProposal.outline3 || "",
              outline4: res.thesisProposal.outline4 || "",
            };
          }
          if (res.router == "addThesisProposal") {
            this.$router.push({
              path: "/main/addThesisProposal",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } else if (res.router == "myThesisProposal") {
            // this.$router.push({
            //   path: "/main/myThesisProposal",
            //   query: { thesisBatchId: this.defaultThesisBatchId },
            // });
            this.gonggao(res.config.notice);
          } else if (res.router == "myThesis") {
            this.$router.push({
              path: "/main/thesis2",
              query: { thesisBatchId: this.defaultThesisBatchId },
            });
          } 
        });
    },
    gonggao(n) {
      if (
        this.config.notice &&
        (!this.$utils.toTime(this.config.noticetaskAssignEndDate) ||
          this.$utils.toTime(this.config.noticetaskAssignEndDate) > this.nowDate)
      ) {
        const u_id = this.$store.state.user.userId + "2";
        if (!sessionStorage.getItem(u_id) && n) {
          this.$refs.Notice.open(n,()=>{
          sessionStorage.setItem(u_id, "1");
          })
        }
      }
    },
    updateThesisProposal() {
      this.$router.push({
        path: "/main/updateThesisProposal",
        query: { thesisBatchId: this.defaultThesisBatchId },
      });
    },
    addThesisProposal() {
      this.$router.push({
        path: "/main/addThesisProposal",
        query: { thesisBatchId: this.defaultThesisBatchId },
      });
    },
    openPledgeDialog() {
      if (!this.thesisProposal || !this.$refs.pledgeDialog) return;
      const payload = this.buildPledgePayload();
      payload.signImg = this.pledgeSign || "";
      payload.signType = "pledge"; // 标记这是承诺书签名
      this.$refs.pledgeDialog.open(payload, () => {
        // 承诺书签名提交后的回调
      });
    },
    buildPledgePayload() {
      const userInfo = this.$store.state.user || {};
      const bmInfo = this.bm || {};
      return {
        cnTitle: (this.thesisProposal && this.thesisProposal.title) || "",
        enTitle: (this.thesisProposal && this.thesisProposal.enName) || "",
        stuName:
          userInfo.realname ||
          userInfo.realName ||
          userInfo.name ||
          userInfo.username ||
          userInfo.uname ||
          "",
        stuNo:
          userInfo.certiNo ||
          userInfo.username ||
          "",
        admissionNo: (bmInfo && (bmInfo.ticketNo || bmInfo.examNo)) || "",
        major:
          (this.thesisProposal && this.thesisProposal.specialtyCode && `${this.thesisProposal.specialtyCode}-${this.thesisProposal.specialtyName}`) ||
          (this.thesisProposal && this.thesisProposal.direction) ||
          (this.info &&
            (this.info.spec_code || this.info.spec_name) &&
            `${this.info.spec_code ? this.info.spec_code + "-" : ""}${
              this.info.spec_name || ""
            }`) ||
          "",
        className: (bmInfo && (bmInfo.className || bmInfo.clazzName)) || "",
        thesisBatchId: this.defaultThesisBatchId || "",
        date: new Date(),
        historySign: this.pledgeSign || "",
        id: this.thesisProposal.id
      };
    },
    onSignSelected(sign) {
      this.pledgeSign = sign || "";
      // 根据签名类型更新对应的字段
      // 这个事件在签名选择时触发，但此时还不知道是哪种类型，所以暂时都更新
    },
    onPledgeConfirm(pledgeData) {
      this.pledgeSign =
        (pledgeData && pledgeData.signImg) || this.pledgeSign || "";
      
      // 根据签名类型处理不同的逻辑
      if (pledgeData && pledgeData.signType === "taskbook") {
        // 任务书签名：只更新表单字段，不提交承诺书
        // this.taskBookForm.signImg = this.pledgeSign;
        // this.$refs.taskBookForm && this.$refs.taskBookForm.validateField('signImg');
        // this.$message({
        //   showClose: true,
        //   message: "任务书签名已保存！",
        //   type: "success",
        // });
      } else {
        // 承诺书签名：提交承诺书并刷新数据
        this.getInfo();
        this.$message({
          showClose: true,
          message: "承诺书签名已提交成功！请继续填写任务书和开题报告。",
          type: "success",
          duration: 5000,
        });
      }
    },
    savePledgeSign() {
      if (!this.thesisProposal || !this.pledgeSign) return;
      const params = {
        thesisBatchId: this.defaultThesisBatchId,
        id: this.thesisProposal.id,
        direction: this.thesisProposal.direction || "",
        title: this.thesisProposal.title || "",
        questionId: this.thesisProposal.questionId || "",
        outline1: this.thesisProposal.outline1 || "",
        outline2: this.thesisProposal.outline2 || "",
        outline3: this.thesisProposal.outline3 || "",
        outline4: this.thesisProposal.outline4 || "",
        signImg: this.pledgeSign,
      };
      this.$http
        .post("/student/thesisProposal2/update", params)
        .then((res) => {
          if (res) {
            this.$message({
              showClose: true,
              message: "签名已保存。",
              type: "success",
            });
            this.getInfo();
          }
        });
    },
    openTaskBookSignDialog() {
      if (this.taskBook.studentTaskBookSign) {
        return
      }
      this.$refs.signDialog.open()
      return
      // 任务书签名也使用同一个 pledgeDialog 组件
      if (!this.thesisProposal || !this.$refs.pledgeDialog) return;
      const payload = this.buildPledgePayload();
      payload.signImg = this.taskBookForm.signImg || "";
      payload.signType = "taskbook"; // 标记这是任务书签名
      this.$refs.pledgeDialog.open(payload, () => {
        // 任务书签名不提交承诺书，只更新表单字段
        if (this.pledgeSign) {
          this.taskBookForm.signImg = this.pledgeSign;
          this.$refs.taskBookForm && this.$refs.taskBookForm.validateField('signImg');
        }
      });
    },
    onSign(src) {
      this.taskBookForm.studentTaskBookSign = src
      this.$refs.taskBookForm && this.$refs.taskBookForm.validateField('studentTaskBookSign');
    },
    clearTaskBookSign() {
      this.taskBookForm.signImg = "";
    },
    submitTaskBook() {
      this.$refs.taskBookForm.validate((valid) => {
        if (valid) {
          const params = {
            thesisProposalId: this.thesisProposal.id,
            taskAssignStartDate: this.taskBookForm.taskAssignStartDate,
            taskAssignEndDate: this.taskBookForm.taskAssignEndDate,
            mainContent: this.taskBookForm.mainContent,
            mainWorkPlan: this.taskBookForm.mainWorkPlan,
            studentTaskBookSign: this.taskBookForm.studentTaskBookSign,
          };
          this.$confirm("请仔细核对内容，确认无误后提交。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then((res) => {
            if (res == "confirm") {
              this.$http.post("/student/taskbook/submit", params).then((res) => {
                this.$message({
                  showClose: true,
                  message: "任务书提交成功！",
                  type: "success",
                });
                this.getInfo();
              });
            }
          });
        }
      });
    },
    submitProposal() {
      this.$refs.proposalForm.validate((valid) => {
        if (valid) {
          const params = {
            ...this.proposalForm,
            // thesisBatchId: this.defaultThesisBatchId,
            id: this.thesisProposal.id,
            // direction: this.thesisProposal.direction || "",
            // title: this.thesisProposal.title || "",
            // questionId: this.thesisProposal.questionId || "",
          };
          this.$confirm("请仔细核对内容，确认无误后提交。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then((res) => {
            if (res == "confirm") {
              this.$http
                .post("/student/thesisProposal2/update", params)
                .then((res) => {
                  if (res) {
                    this.$message({
                      showClose: true,
                      message: "开题报告提交成功！",
                      type: "success",
                    });
                    this.getInfo();
                  }
                });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.xw_required {
  color: #f00;
}
#form_thesisProposal_add {
  .el-form-item {
    margin-bottom: 0;
  }
  &::v-deep .el-form-item__label {
    background: #f5f5f5;
  }
}
.el-button {
  margin: 10px;
}
.pledge-section {
  margin-top: 16px;
  border: 1px solid #e5e5e5;
  padding: 12px;
  border-radius: 4px;
  background: #fafafa;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    font-weight: 600;
  }
  &__body {
    display: flex;
    align-items: center;
    gap: 12px;
    img {
      height: 44px;
      border: 1px solid #e5e5e5;
      padding: 4px;
      background: #fff;
    }
  }
  &__placeholder {
    color: #999;
  }
}
.task-proposal-section {
  margin-top: 16px;
  .task-proposal-tabs {
    margin-bottom: 16px;
  }
  .submit-buttons {
    text-align: right;
    padding: 16px 0;
  }
}
.pledge-sign-box {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.pledge-sign-preview {
  height: 44px;
  padding: 4px;
  cursor: pointer;
}
.pledge-sign-placeholder {
  color: #999;
}
</style>
